import { render, staticRenderFns } from "./TableFieldConfiguratorRows.vue?vue&type=template&id=1ba50e5a"
import script from "./TableFieldConfiguratorRows.vue?vue&type=script&lang=js"
export * from "./TableFieldConfiguratorRows.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports